import React, { Component } from 'react'
import { Register } from '../components'

class RegisterContainer extends Component {
  render() {
    return <Register />
  }
}

export default RegisterContainer


// WEBPACK FOOTER //
// ./src/containers/RegisterContainer.js